import React from 'react';
import './zaytooon.css';
import Navbar from '../../components/Navbar/Navbar';
const Zaytooon = () => {
    return (
        <div className='zaytooon-page'>
            <Navbar />
            <h1 className='under-development-title'>Under Development</h1>
            <p className='under-development-subtitle'>this page is currently under development and isn't Ready Yet  :) </p>



        </div>

    );





};
export default Zaytooon;